import { Box, Button, Text } from '@usealloy/component-library';
import styled from 'styled-components';
import { EditorContainerType } from 'flow/store/redux/constants';
import { SIMPLE_ISLAND_EXPANDED_RIGHT } from '~/dashboard/views/workflows/editor/components/Island/BaseSimpleIsland';
import type { IslandMode } from '~/dashboard/views/workflows/editor/components/Island/BaseSimpleIsland';

export const StyledSectionHeader = styled(Text)`
  && {
    color: var(--cl-gray-700);
  }
`;

export const StyledTagDescription = styled(Text)`
  && {
    line-height: var(--cl-font-size-4);
  }
`;

export const StyledEvidencesSection = styled(Box)<{ evaluationExplainability: boolean }>`
  border-top: 1px solid var(--cl-gray-500);
  padding-top: var(--cl-space-5);
  ${({ evaluationExplainability }) => (
    evaluationExplainability && `
      padding-left: calc(26px + var(--cl-space-6));
      padding-right: var(--cl-space-6);
    `
  )}
`;

export const StyledWorkflowCanvasContainer = styled(Box)`
  width: 100%;
  height: 100%;
`;

export const StyledHeader = styled(Box)`
  display: flex;
  width: 96%;
  left: 0px;
`;

export const StyledToggleButton = styled(Button)`
  background-color: transparent;
  width: 10rem;
  display: flex;
  justify-content: flex-start;
`;

interface StyledSearchBoxContainerProps {
  containerType: EditorContainerType;
  islandMode: IslandMode;
}

/* ONLY affects container type PAGE: right offset that aligns a caller's right edge with the outcome island's right edge. */
function getIslandAwareRightOffset(islandMode: IslandMode): string {
  return islandMode === 'expanded' ? `${SIMPLE_ISLAND_EXPANDED_RIGHT}px` : '0';
}

/* Affects container type PAGE: this gets an elevated z-index and aligns with StyledSearchTriggerRow. */
export const StyledSearchBoxContainer = styled.div<StyledSearchBoxContainerProps>`
  position: absolute;
  top: 73px;
  right: ${p => (p.containerType === EditorContainerType.PAGE
    ? getIslandAwareRightOffset(p.islandMode)
    : 'var(--cl-space-8)')};
  ${p => (p.containerType === EditorContainerType.PAGE ? 'z-index: var(--cl-zindex-popover);' : '')}
`;

/* The legacy TagRuleModal's original search trigger, used only for modal container type. */
export const StyledSearchTriggerContainer = styled.div`
  position: absolute;
  top: var(--cl-space-4);
  right: var(--cl-space-16);
`;

interface StyledSearchTriggerRowProps {
  islandMode: IslandMode;
}

/* Affects container type PAGE: sits in normal document flow so it never overlaps the canvas. */
export const StyledSearchTriggerRow = styled.div<StyledSearchTriggerRowProps>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-right: ${p => getIslandAwareRightOffset(p.islandMode)};
`;
